import { PaletteSwatchOutlineIcon } from './PaletteSwatchOutlineIcon';

/**
 * author: Google
 * id 3D2690B4-4A3D-4B7C-B384-1C0AB180DD0B
 * name palette-swatch-outline
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/palette-swatch-outline.svg
 * tags
 * - Drawing / Art 
 * - Color 
 */
export const StyleOutlineIcon = PaletteSwatchOutlineIcon;
export default StyleOutlineIcon